import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, withState, branch, renderComponent } from 'recompose'
import { push } from 'react-router-redux'

import { page, track } from 'utils/trackingUtils'
import * as MeetingsSelectors from 'modules/meetings/selectors'
import * as MeetingsActions from 'modules/meetings/actions'
import * as ProfileActions from 'modules/profile/actions'
import * as UserSelectors from 'modules/user/selectors'

import { CalendarSelectStep, AECalendarSelectStep } from './component'

const mapStateToProps = state => ({
  isGoogleAuthed: MeetingsSelectors.isGoogleAuthed(state),
  isMicrosoftAuthed: MeetingsSelectors.isMicrosoftAuthed(state),
  calendars: MeetingsSelectors.getCalendars(state),
  isFetchCalendarLoading: MeetingsSelectors.isFetchCalendarLoading(state),
  isRepInvitedFlow: UserSelectors.isRepInvitedFlow(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchCalendarStatus: MeetingsActions.fetchCalendarStatus,
    updateGoogleCalendar: MeetingsActions.updateGoogleCalendar,
    updateMicrosoftCalendar: MeetingsActions.updateMicrosoftCalendar,
    updateProfile: ProfileActions.updateProfile,
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Meetings Calendar Select', {
        context: this.props.isCalendarSeat 
          ? 'calendaring-seat-onboarding' 
          : this.props.isRepInvitedFlow 
          ? 'rep-onboarding' 
          : 'sales-onboarding',
        method: this.props.isGoogleAuthed ? 'google-calendar' : 'microsoft-calendar'
      })
    }
  }),
  withState('calendarSelected', 'setCalendarSelected', null),
  withHandlers({
    onCalendarSelect: props => () => {
      const {
        actions: {
          updateGoogleCalendar,
          updateMicrosoftCalendar,
          push,
          updateProfile
        },
        calendarSelected,
        isGoogleAuthed,
        isRepInvitedFlow,
        isCalendarSeat
      } = props
      const updateFunc = isGoogleAuthed ? updateGoogleCalendar : updateMicrosoftCalendar
      updateFunc({
        id: calendarSelected.value,
        name: calendarSelected.label
      })
      updateProfile([
        {
          operation: 'set',
          property: 'enableCalendarCta',
          value: true 
        }
      ])
      track('Onboarding Meetings Setup Completed', {
        context: isCalendarSeat 
          ? 'calendaring-seat-onboarding' 
          : isRepInvitedFlow 
          ? 'rep-onboarding' 
          : 'sales-onboarding',
        method: isGoogleAuthed ? 'google-calendar' : 'microsoft-calendar'
      })
      if (props.isCalendarSeat) {
        // skipping the extension step for now
        // push('/setup/calendaring/extension')
        push('/setup/calendaring/hooray')
      } else {
        push('/setup/extension')
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchCalendarStatus()
    },
    componentDidUpdate(prevProps) {
      // calendar list is nested for one lifecycle
      if (!!prevProps.calendars.calendars && prevProps.calendars.calendars.length !== 0) {
        const firstCal = this.props.calendars[0]
        const firstCalValue = {label: firstCal.name, value: firstCal.id}
        this.props.setCalendarSelected(firstCalValue)
      }
    }
  }),
  branch(props => props.isCalendarSeat, renderComponent(AECalendarSelectStep)),
)(CalendarSelectStep)



// WEBPACK FOOTER //
// ./src/layouts/CalendarSelectStep/index.js